import VipAlert from "./VipAlert";

export default VipAlert;